/**
 * AUTO-GENERATED FILE. Do not edit.
 */
export const ACTIVE_RUNTIME_MODE: 'development' | 'production' = 'production';
export const ACTIVE_ENVIRONMENT_NAME = 'production';
export const ACTIVE_API_URL = 'https://api.stoneplanner.app';
